import { gql, useLazyQuery, useQuery } from '@apollo/client'
import { Metadata, ResultsList, SearchGraphql } from '../../../../../core/models'
import { ProgramTrainer } from '../../models'
import { useEffect, useState } from 'react'

const GET_TRAINERS = gql`
  query GetProgramTrainers($where: ProgramTrainerFilterInput!, $skip: Int, $take: Int) {
    programTrainers(where: $where, skip: $skip, take: $take, order: { name: ASC }) {
      items {
        id
        name
        active
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`

interface TrainersData {
  programTrainers: {
    totalCount: number
    items: ProgramTrainer[]
  }
}

export const useProgramTrainers = () => {
  const [getResults, { loading, error, data }] = useLazyQuery<TrainersData>(GET_TRAINERS, {
    fetchPolicy: 'network-only',
  })

  const [results, setResults] = useState<ResultsList<ProgramTrainer, Metadata>>({
    results: [],
    metadata: {},
  })

  const getProgramTrainers = ({ where, take, skip }: SearchGraphql) => {
    getResults({
      variables: {
        where: { ...where },
        skip: skip ? skip : 0,
        take: take ? take : 100,
      },
    })
  }

  useEffect(() => {
    if (data?.programTrainers) {
      setResults({
        results: data?.programTrainers.items || [],
        metadata: {
          Count: data?.programTrainers.totalCount,
        },
      })
    }
  }, [loading])

  return { getProgramTrainers, loading, error, results }
}
